import { createStyles, getStylesRef, Group, Stack } from '@mantine/core';
import React from 'react';

import { useStoreListingWizard } from '../hooks';
import { StepId } from '../types';

export function MenuNavigation() {
  const { cx, classes } = useStyles();
  const { skipToStep, currentStep } = useStoreListingWizard();

  const onClick = async (stepId: StepId) => {
    if (currentStep.id === stepId) return;

    await skipToStep(stepId);
  };

  return (
    <Stack spacing="xs">
      <Group
        onClick={() => onClick(StepId.ChooseProduct)}
        className={cx(classes.navItem, {
          [classes.active]: currentStep.id === StepId.ChooseProduct,
        })}
        data-testid="menu-navigation-product-information"
      >
        Product Information
      </Group>

      <Group
        onClick={() => onClick(StepId.PaymentSettings)}
        className={cx(classes.navItem, {
          [classes.active]: currentStep.id === StepId.PaymentSettings,
        })}
        data-testid="menu-navigation-payment-settings"
      >
        Payment Settings
      </Group>
    </Stack>
  );
}

const useStyles = createStyles((theme) => ({
  navItem: {
    height: 40,
    paddingLeft: theme.spacing.md,
    paddingRight: theme.spacing.sm,
    borderRadius: theme.radius.xl,
    color: theme.colors.blue_gray[7],
    cursor: 'pointer',
    userSelect: 'none',

    [`:hover:not(.${getStylesRef('active')})`]: {
      color: theme.colors.blue_gray[9],
      backgroundColor: theme.colors.gray[0],
    },
  },
  active: {
    ref: getStylesRef('active'),
    color: theme.other.primaryColor,
    backgroundColor: theme.fn.rgba(theme.colors.blue[0], 0.5),
  },
}));
